import { cloneDeep } from "lodash";
import { sitesPipelineStore } from "../store";

export const moveSiteBetweenStages = ({
  sourceStageId,
  targetStageId,
  fromIndex,
  toIndex,
}: {
  sourceStageId: string;
  targetStageId: string;
  fromIndex: number;
  toIndex: number;
}) => {
  const updatedSourceSiteIds = cloneDeep(sitesPipelineStore.orderedSiteIdsByStageId[sourceStageId]);
  const updatedTargetSiteIds = cloneDeep(sitesPipelineStore.orderedSiteIdsByStageId[targetStageId]);

  if (!updatedSourceSiteIds) return;
  if (!updatedTargetSiteIds) return;
  if (updatedSourceSiteIds.length < fromIndex) return;
  if (updatedTargetSiteIds.length < toIndex) return;

  const [siteId] = updatedSourceSiteIds.splice(fromIndex, 1);

  if (!siteId) {
    // if we're moving around really fast, we can sometimes miss a sitesByStage state update and the internal state won't be in the right position and site will be undefined
    // In this case, we ignore the update otherwise we will corrupt our internal state with empty data
    return;
  }

  sitesPipelineStore.stageByStageId[sourceStageId]._sites.totalCount--;
  sitesPipelineStore.stageByStageId[targetStageId]._sites.totalCount++;

  updatedTargetSiteIds.splice(toIndex, 0, siteId);
  sitesPipelineStore.orderedSiteIdsByStageId[sourceStageId] = updatedSourceSiteIds;
  sitesPipelineStore.orderedSiteIdsByStageId[targetStageId] = updatedTargetSiteIds;
};
